<template>
  <div>
    <v-dialog
        v-if="changePasswordDialog"
        v-model="changePasswordDialog"
        max-width="400px"
        overlay-opacity=.1
        persistent
    >
      <v-card class="neu-glow">
        <v-card-title>
          <vuse-section-definition
              :title=" $t('Global.Profile.changePassword')"
              icon="mdi-lock-reset"
              class="ml-n4 pa-0 pb-4" />
        </v-card-title>
        <v-card-text>
          <v-form ref="changePasswordForm">
            <v-sheet class="neu-glow px-10 py-6">
              <v-row>
                <v-text-field
                    v-model="firstPassword"
                    @input="validate"
                    :label="$t('Global.Profile.enterPassword')+'*'"
                    :rules="[ validPassword ]"
                    required
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                    v-model="secondPassword"
                    @input="validate"
                    :label="$t('Global.Profile.reenterPassword')+'*'"
                    :rules="[ validPassword, matchPassword ]"
                    required
                ></v-text-field>
              </v-row>
            </v-sheet>
          </v-form>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn color="blue darken-1" text @click="submitChange" :disabled="!validForm">{{ $t('Global.Profile.save') }}</v-btn>
          <v-btn color="blue darken-1" text @click="cancelDialog">{{ $t('Global.Profile.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
      <confirm-dialog
          ref="confirmPasswordDialog"
          :title="$t('Global.ConfirmDialog.changeDataUserTitle')"
          :message="$t('Global.ConfirmDialog.changeMessageUserPassword')"
      />
    </v-dialog>
    <v-snackbar
        v-model="snackbar"
        fixed
        right
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        class="mb-8"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>

</template>

<script>
import UserInfoApi from "@/mixins/Services/UserInfoApi"
import loader from "@/mixins/Loader"
import ConfirmDialog from "@/components/UI/Dialogs/ConfirmDialog"
import Utils from "@/mixins/Utils";
import snackBar from "@/mixins/snackBarMixin";

export default {
    name: "ProfileChangePasswordDialog",
    components: {
        ConfirmDialog
    },
    mixins: [UserInfoApi, loader, Utils, snackBar],
    props: {
        changePasswordDialog: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        return {
            firstPassword: "",
            secondPassword: "",
            validPassword: v => v.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@.,!%*?&:;/¿¡€#+·=<>ñç_])[A-Za-z0-9@.,!%*?&:;/¿¡€#+·=<>ñç_]{8,}$/) ? true : this.$t('Global.FormRules.invalidFormat'),
            matchPassword: v => v === this.firstPassword ? true : this.$t('Global.FormRules.passwordError'),
            validForm: false
        }
    },
    methods: {
        validate() {
            if (this.$refs.changePasswordForm.validate())
                this.validForm = true
            else
                this.validForm = false
        },
        cancelDialog() {
            this.firstPassword = ""
            this.secondPassword = ""
            this.$emit('close-dialog')
        },
        async submitChange(){
            const confirm = await this.$refs.confirmPasswordDialog.open()
            if (!confirm) return
          try {
            this.setLoader(true)
            await this.changePassword(this.firstPassword)
            this.setLoader(false)
            await this.launchSnackbar(this.$t("Global.Profile.changePasswordOk"),'success','4000','mdi-check-circle')
            this.cancelDialog()
            this.$emit('close-dialog')
          }catch (e) {
            console.error('[PROFILE_CHANGE_PASSWORD_DIALOG][submitChange] ERROR:', e)
            this.setLoader(false)
            if(this.isErrorText(e)){
              const textError = this.getErrorText(e);
              this.launchSnackbar(this.$t(`Global.Error.c${textError}`), 'error', "2000", 'mdi-alert-octagon')
            }
            this.cancelDialog()
          }
        }
    }
}
</script>

<style>

</style>
